<template>
  <div class="Book mb-16">
    <h1 class="text-center dastnevis my-10">
      مجموعه کتاب های بسته توسعه سواد خواندن
    </h1>
    <div v-for="item in series" :key="item.name" class="py-16">
      <BookList :series="item.name" :grade="item.grade" :right="item.right" />
    </div>
  </div>
</template>
<script>
import BookList from "../components/BookList.vue";

export default {
  name: "books-component",
  components: {
    BookList
  },
  data() {
    return {
      series: [
        {
          name: "داستان‌هایی از زبان حیوانات - بخش اول",
          grade: "اول دبستان",
          right: true
        },
        {
          name: "داستان‌هایی از زبان حیوانات - بخش دوم",
          grade: "دوم دبستان",
          right: false
        },
        {
          name: "داستان‌های لولوبی‌ها",
          grade: "سوم دبستان",
          right: true
        },
        {
          name: "داستان‌های لولوبی‌ها و ماناها",
          grade: "چهارم دبستان",
          right: false
        },
        {
          name: "داستان‌های ماناها",
          grade: "پنجم دبستان",
          right: true
        },
        {
          name: "داستان‌های احسان و عرفان",
          grade: "ششم دبستان",
          right: false
        }
      ]
    };
  }
};
</script>
